module.exports = __webpack_public_path__ + "img/premium.f41d81a7.jpg";